import { render, staticRenderFns } from "./basicSetting.vue?vue&type=template&id=40288f54&scoped=true"
import script from "./basicSetting.vue?vue&type=script&lang=js"
export * from "./basicSetting.vue?vue&type=script&lang=js"
import style0 from "./basicSetting.vue?vue&type=style&index=0&id=40288f54&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40288f54",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40288f54')) {
      api.createRecord('40288f54', component.options)
    } else {
      api.reload('40288f54', component.options)
    }
    module.hot.accept("./basicSetting.vue?vue&type=template&id=40288f54&scoped=true", function () {
      api.rerender('40288f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/develop/crud/components/basicSetting.vue"
export default component.exports